import React from 'react';
import { isEmpty, cloneDeep } from 'lodash';

import InputAdornment from '@material-ui/core/InputAdornment';
import TextField from '@material-ui/core/TextField';
import PlacesAutocomplete, { geocodeByAddress } from 'react-places-autocomplete';

import ACStatus from '../../atoms/ACStatus';

import styles from './MoreToExploreDetails.module.scss';
export default class MoreToExploreDetails extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};

    this.onChangeAddress = this.onChangeAddress.bind(this);
    this.onSelectAddress = this.onSelectAddress.bind(this);
    this.onChangeText = this.onChangeText.bind(this);
  }

  onChangeAddress(address) {
    let where = {
      address,
    };

    this.props.onUpdateMoreToExploreAddressFunc(where);
  }

  onChangeText(key, event) {
    let value = event.target.value;
    this.props.onUpdateMoreToExploreFunc(key, value);
  }

  onSelectAddress(address) {
    geocodeByAddress(address)
      .then(results => {
        if (results && results[0]) {
          let r = results[0];

          let where = {};

          if (!r.address_components) return;
          const acs = r.address_components;

          const country = acs.find(ac => {
            return ac.types.includes('country');
          });
          country && country.long_name ? (where.country = country.long_name) : (where.country = '');

          const state = acs.find(ac => {
            return ac.types.includes('administrative_area_level_1');
          });
          state && state.long_name ? (where.state = state.long_name) : (where.state = '');

          const city = acs.find(ac => {
            return ac.types.includes('locality');
          });
          city && city.long_name ? (where.city = city.long_name) : (where.city = '');
          where.address = r.formatted_address || '';

          this.props.onUpdateMoreToExploreAddressFunc(where);
        }
      })
      .catch(error => console.error('Error', error));
  }

  renderTop(moreToExplore) {
    const { name = '', status = '' } = moreToExplore;

    return (
      <div className={styles.top}>
        <div className={styles.header}>Details</div>
        <div>
          <span className={styles.moreToExploreName}>
            <div className={styles.name}>
              <TextField
                value={name}
                className={styles.nameText}
                onChange={e => this.onChangeText('name', e)}
                placeholder="Name"
              />
            </div>
          </span>
          <ACStatus
            status={status}
            text={status}
            isEditable={true}
            type="moreToExplore"
            onChangeFunc={e => this.onChangeText('status', e)}
            key="moreToExploreStatusKey"
          />
        </div>
      </div>
    );
  }

  renderAddressDetails(moreToExplore) {
    const { where = { address: '', city: '', state: '', country: '' } } = moreToExplore;

    const { address, city, state, country } = where;

    return (
      <div>
        {' '}
        <PlacesAutocomplete
          value={address}
          onChange={this.onChangeAddress}
          onSelect={this.onSelectAddress}
        >
          {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
            <div className={styles.placesAutoComplete}>
              <div className={styles.placesAutoCompleteMain}>
                <span>Address</span>
                <input
                  {...getInputProps({
                    placeholder: 'Address, Suburb, State, Country',
                  })}
                />
              </div>
              <div className={styles.placesAutoCompleteSelect}>
                {loading && <div>Loading...</div>}
                {suggestions.map(suggestion => {
                  const className = suggestion.active
                    ? styles.suggestionItemActive
                    : styles.suggestionItem;
                  return (
                    <div
                      {...getSuggestionItemProps(suggestion, {
                        className,
                      })}
                    >
                      <span>{suggestion.description}</span>
                    </div>
                  );
                })}
              </div>
            </div>
          )}
        </PlacesAutocomplete>
        <TextField
          id="simple-start-adornment"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start" className={styles.adornment}>
                City
              </InputAdornment>
            ),
          }}
          value={city}
          className={styles.textField}
          disabled
        />
        <TextField
          id="simple-start-adornment"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start" className={styles.adornment}>
                State
              </InputAdornment>
            ),
          }}
          value={state}
          className={styles.textField}
          disabled
        />
        <TextField
          id="simple-start-adornment"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start" className={styles.adornment}>
                Country
              </InputAdornment>
            ),
          }}
          value={country}
          className={styles.textField}
          disabled
        />
      </div>
    );
  }

  render() {
    const { moreToExplore } = cloneDeep(this.props);
    if (isEmpty(moreToExplore)) return <div />;

    return (
      <div className={styles.root}>
        {this.renderTop(moreToExplore)}

        <div className={styles.bottom}>{this.renderAddressDetails(moreToExplore)}</div>
      </div>
    );
  }
}
